export default "__VITE_ASSET__6cLbi0dh__"